export default {
    actions: {
        //return true if area object has a 'completed' area item
        isCompleted : function( area ){
            if( !area.hasOwnProperty('InspectionAreaItems')){
                return false;
            }
            for( let areaItem of area.InspectionAreaItems ){
                if( areaItem.Name == 'COMPLETED' ){
                    return true;
                }
            }
        },
        allAreasCompleted : function( inspection ) {
            if( !inspection.hasOwnProperty('InspectionAreas')){
                return false;
            }
            for( let area of inspection.InspectionAreas ){
                if( !this.isCompleted( area ) ){
                    return false;
                }
            }
            return true;
        }
    }
  }